<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.service{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/合成基因组学产品及服务/bg.png") no-repeat;
  background-size: 100% 100%;
}
.required{
  margin-top: 70px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
.effect-lists1{
  //display: block!important;
  justify-content: center;
  flex-wrap:wrap;
  overflow: auto;
}
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.table td{
  text-align: justify;
  padding: 10px;
}
.mt30 h4{
  display: inline-block;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .container100{
    margin-bottom: 20px!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <!--    <div class="banner" >-->
    <!--      <img src="@/assets/img/产品及服务/基因组测序/banner.png" class="img-fluid">-->
    <!--      <div class="info">-->

    <!--      </div>-->
    <!--    </div>-->
    <div class="container container10">
      <h1>病毒基因组测序</h1>
      <h2 class="mt10">Viral Genome Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
        <p class="desc">病毒（Biological virus）是一种个体微小，结构简单，只含一种核酸 （DNA或RNA），必须在活细胞内寄生并以复制方式增殖的非细胞型生物。病毒会引起人以及动植物产生疾病，这些疾病会严重威胁人类、动植物的生命安全，以及动植物的经济价值等。对病毒样本进行处理，使用高通量NGS（Next Generation Sequencing，二代测序）对病毒全基因组进行测序，这是研究病毒进化、毒力因子变异、疫病爆发之间的关系、疫病传播途径、疫病发生地理区域的基础；对人类科学以及生物安全至关重要。</p>
        <p class="desc">随着NGS技术的发展、测序成本的降低、分析算法与工具的完善，使病毒全基因组测序（WGS）成为病毒研究的重要技术手段。NGS与传统Sanger测序相比，可以得到病毒株的全基因组序列，结果更加完善；但其产生的数据量非常庞大，这也增加了序列拼接的难度。对于低浓度高复杂度的样本，研究者只能用PCR方法。但是PCR方法往往都会存在偏好性，丢失的片段将为序列组装带来非常高的失败率。对于未知的样本，无法通过PCR进行富集，要鉴定其种类需要调用各种方法，逐个尝试，工作量大，效率低。而使用NGS技术可以直接高深度对样品所有核酸进行高通量测序，拼接得到病毒全基因组序列，能检测包括目的病毒在内的所有可能感染的病原微生物基因序列，从而展开下游分析。</p>
        <p class="desc">针对目前新冠疫情，对病毒进行WGS测序可以及时发现病毒、分析病毒来源、动态地监测病毒变异的情况，为后续研究病毒变异对病原检测和疫苗保护效果影响、调整防控政策等提供科学的依据。</p>
      </div>
      <div class="container">
        <div class="c-title">服务类型<small>Service type</small></div>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            :data="tableData">
            <el-table-column
              prop="method1"
              label="病毒类型">
            </el-table-column>
            <el-table-column
              prop="method2"
              label="DNA、RNA病毒全基因组">
            </el-table-column>
            <el-table-column
              prop="method3"
              label="宏病毒组">
            </el-table-column>
            <el-table-column
              prop="method4"
              label="宏病毒组">
            </el-table-column>
            <el-table-column
              prop="method5"
              label="未知病毒基因组">
            </el-table-column>
          </el-table>
        </div>
        <div class="mt30"><h4>注意：</h4>送样前需要询问销售填写<h4>样本信息表</h4>，对样本进行可行性评估，降低失败风险。</div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/ge_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/ge_${item.img}${currentService===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components:{
    bread
  },
  data () {
    return {
      tableData:[
        {
          method1:'可接受样本',
          method2:`
            1.提取好的DNA、RNA核酸;
            2.P2安全等级及以下的微生物临床标本;
            3.P2安全等级及以下的病毒培养物的冻融上清液
          `,
          method3:`
            1.提取好的DNA核酸;
            2.提取好的RNA核酸;
            3.P2安全等级及以下的标本或者培养物
          `,
          method4:`
             1.提取好的RNA;
             2.提取好的dsDNA
          `,
          method5:`
            1.提取好的DNA;
            2.提取好的RNA;
            3.P2安全等级及以下的微生物临床标本;
            4.P2安全等级及以下的病毒培养物的冻融上清液
          `,
       },
        {
          method1:'送样前注意事项',
          method2:`
            1.获得指定DNA、RNA病毒的序列;
            2.目的病毒的中英文名称;
            3.样本中病毒的载量情况、培养状况、ct值等任一信息;
            4.qPCR验证ct值在25以下或者使用PCR验证25次循环有条带
          `,
          method3:`
            1.获得样本中尽量多的病毒物种名称、比例和序列;
            2.并非一定拿到病毒的全序列
          `,
          method4:`
            1.分离的噬菌体样本信息及序列;
            2.噬菌体核酸类型：是RNA还是DNA;
            3.DNA噬菌体是单链还是双链;
            4.自行提取好核酸并确保无宿主基因组污染
          `,
          method5:`
            1.分离好的未知病毒样本信息及序列;
            2.样本中病毒的载量情况、培养状况等任一信息，确定有病毒
          `,
        },
        {
          method1:'备注',
          method2:'-',
          method3:'对样本中所有的病毒进行测序，对样本中的核酸进行无差别的测序，无需特异性引物扩增。最终获得所有病毒的名称所占比例、以及部分或者全部基因组序列。',
          method4:'噬菌体是侵袭细菌的病毒，也是赋予宿主菌生物学性状的遗传物质。对于刚分离出的噬菌体，其基因组是未知的，要对这种样本进行基因组测序，采用二代测序不依赖特异性引物的方式最为适合。',
          method5:'在标本中用细胞等体外分离到的毒株，使用二代测序的“无差别处理”特征以及生物信息学分析流程和数据库可以实现鉴定目的。',
        },
      ],
      currentService: -1,
      types1: [
        {name: '人全基因组重测序', img: '1', ref: '/tec/human_sequencing'},
        {name: '人全外显子测序', img: '2', ref: '/tec/whole_exome'},
        {name: '动植物重测序', img: '3', ref: '/tec/Plant_animal_resequencing'},
        {name: '叶绿体/线粒体测序', img: '4', ref: '/tec/mitochondrial'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.reload()
    this.getResourceColumns()
    console.log(this.$route)
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/Viral_genome_sequencing.vue